// extracted by mini-css-extract-plugin
export default {"container":"Feedback_container__F+xKN","input_container":"Feedback_input_container__J3s8D","feedback":"Feedback_feedback__XtWvP","error":"Feedback_error__ByClx"};